//Polyfills
import "@limitless/common/utils/polyfills/PortalPolyfills";
import "core-js/modules/es.symbol";
// Limitless imports
import { loadPortalApplication } from "@limitless/portal/utils/app-loaders/PortalAppLoader";
import registerServiceWorker from "@limitless/common/utils/service-worker/RegisterServiceWorker";
import { EWA_APP_RESOURCES } from "@limitless/common/apis/resource-api";
import { EXPERT_CONFIG } from "@limitless/common/hooks/app-config/AppConfigHook";
import "./index.css";
import ExpertWebApp from "./ExpertWebApp";

const expertWebAppConfig = {
    PortalApp: ExpertWebApp,
    productionPrefix: "ewa",
    appName: "expert_web_app",
    resourceList: EWA_APP_RESOURCES,
    configItems: EXPERT_CONFIG,
    appAccessPolicy: ["app_access_ewa", "exp_acc"]
};

loadPortalApplication(expertWebAppConfig);
registerServiceWorker();
